import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@assetaccountant/core';
import { OfferInstance } from '@assetaccountant/core/models/offers/offer-instance';
import { OfferKey } from '@assetaccountant/core/models/offers/offer-key';
import { OffersService } from '@assetaccountant/core/services/offers.service';

@Component({
  selector: 'app-offers',
  templateUrl: './offers.component.html',
  styleUrls: ['./offers.component.scss'],
  standalone: false,
})
export class OffersComponent implements OnInit {
  private offerKey: OfferKey | undefined;
  private offerInstance: OfferInstance;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthenticationService,
    private offersService: OffersService,
  ) {}

  get title() {
    return {
      pageTitle: 'FinQuery Fixed Assets Offers',
      pageHeading: [{ name: 'FinQuery Fixed Assets Offers' }],
    };
  }

  get isLoaded() {
    return this.offerInstance != null;
  }

  private getAppRoot(): string {
    return `${location.protocol}//${location.host}`;
  }

  private getProviderName(providerId: number | null): string | null {
    if (providerId !== null) {
      if (providerId === 1) {
        return 'Intuit';
      }
    }
    return null;
  }

  private getAppActionRoute(campaignCouponType: number): string | null {
    if (campaignCouponType === 1) {
      return 'create-organisation-special';
    }
    return null;
  }

  ngOnInit(): void {
    const campaignKey = this.route.snapshot.paramMap.get('campaignKey');
    if (campaignKey) {
      this.offerKey = new OfferKey();
      this.offerKey.campaignKey = campaignKey;
      this.offerKey.couponId = this.route.snapshot.paramMap.get('couponId');
    }
    // Call service to ensure this is a good offer and any constraints
    // we need to know
    // 1 The Provider
    // 2 The Offer Execute url
    // 3 if offer is valid.
    if (this.offerKey !== undefined) {
      this.offersService.getOffer(this.offerKey).subscribe(
        (offerInstance: OfferInstance) => {
          this.offerInstance = offerInstance;
          const offerActionUrl = this.getAppActionRoute(offerInstance.campaignCouponType);

          const relativeOfferActionUrl =
            this.offerInstance.couponScope === 2
              ? `/${offerActionUrl}/${this.offerKey?.campaignKey}`
              : `/${offerActionUrl}/${this.offerKey?.campaignKey}/${this.offerKey?.couponId}`;
          const provider = this.getProviderName(offerInstance.restrictedIntegration);
          if (this.offerInstance.isRedeemable.result) {
            if (!this.authService.isAuthenticated()) {
              const fullOfferActionUrl = `${this.getAppRoot()}/${relativeOfferActionUrl}`;
              if (provider == null) {
                this.authService.init(fullOfferActionUrl);
              } else {
                this.authService.init(fullOfferActionUrl, {
                  acr_values: `idp:${provider}`,
                });
              }
              return;
            } else {
              // Test if current auth is the same provider..
              if (provider != null) {
                if (this.authService.getIdentityProvider() !== provider) {
                  this.offerInstance.isRedeemable.result = false;
                  this.offerInstance.isRedeemable.reason = `This offer is valid for customers who sign in with ${provider} only.  Please logout from FinQuery Fixed Assets and try applying the coupon again.`;
                }
              }
              if (this.offerInstance.isRedeemable.result) {
                this.router.navigate([relativeOfferActionUrl]);
              }
            }
          }
        },
        () => {
          this.offerInstance = {
            isRedeemable: {
              result: false,
              reason: 'Failed to process the offer',
            },
          } as OfferInstance;
        },
      );
    }
  }
  getOfferKey(): string | undefined {
    if (this.offerKey) {
      return this.offerKey?.campaignKey;
    }
    return '';
  }
  get isRedeemable(): boolean {
    if (this.offerInstance && this.offerInstance.isRedeemable) {
      return this.offerInstance.isRedeemable.result;
    }
    return true;
  }
  get isRedeemableMessage(): string {
    if (this.offerInstance && this.offerInstance.isRedeemable) {
      return this.offerInstance.isRedeemable.reason;
    }
    return '';
  }
}
